import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-text-icon',
  templateUrl: './text-text.component.html'
})
export class TextTextComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
